import React from 'react';
import { portal, Portal } from '../../../Configs/general';
import ConstructorInvoiceCardGDC from './ConstructorInvoiceCard.GDC';

const ConstructorInvoiceCard = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <ConstructorInvoiceCardGDC {...props} />;
    default:
      return <></>;
  }
};

export default ConstructorInvoiceCard;
